
import { Vue, Component } from 'vue-property-decorator';
import Api from '@/services/api';
import DatePicker from '@/components/DatePicker.vue';
import moment from 'moment-jalaali';

@Component({ components: { DatePicker } })
export default class Home extends Vue {
  public report = {
    totalCredit: 0,
    disableSimCount: 0,
    activeSimCount: 0,
    simCount: 0,
    packagePrice: 0,
    packageCount: 0,
    chargePrice: 0,
    chargeCount: 0
  };
  public editedItem = {
    fromDate: '',
    toDate: ''
  };
  public defaultItem = {
    fromDate: '',
    toDate: ''
  };

  async created() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push({ name: 'Login' });
    } else {
      const momentInstance = moment();
      this.editedItem.toDate = momentInstance.format('jYYYY/jMM/jDD');
      this.editedItem.fromDate = momentInstance.subtract(7, 'day').format('jYYYY/jMM/jDD');

      await this.initialize();
    }
  }

  async initialize() {
    await this.updateTransaction();
  }

  async updateTransaction() {
    this.$showLoading();
    await Api.getDashboard(this.editedItem).then((response: any) => {
      this.report = response.data;
      this.$hideLoading();
    });
  }

  formatPrice(value: number) {
    const val = (value / 1).toFixed(0).replace('.', ',');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}
